import { Metadata } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import CustomHead from '@/components/molecules/CustomHead'
import ItReportTemplate from '@/components/templates/ItReport'

const ItReport = () => {
  const { t, lang } = useTranslation('it_report')
  const metaData: Metadata = {
    title: t('title'),
    description: t('description'),
  }
  return (
    <>
      <CustomHead metaData={metaData} />
      <ItReportTemplate />
    </>
  )
}

export const getStaticProps = async (context: any) => ({
  props: {},
})

export default ItReport
